/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.

import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
const TrendingSvg = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <mask
      id="a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={21}
      height={20}
    >
      <path fill="currentColor" d="M.75 0h20v20h-20z" />
    </mask>
    <g mask="url(#a)" />
    <path
      d="M11 16.444a2.45 2.45 0 0 0 2.445-2.452C13.445 12.129 11 10 11 10s-2.444 2.13-2.444 3.992A2.45 2.45 0 0 0 11 16.444"
      stroke="currentColor"
      strokeWidth={1.333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 16.445c2.7 0 4.89-2.196 4.89-4.904 0-3.726-4.89-7.985-4.89-7.985s-4.889 4.26-4.889 7.985a4.897 4.897 0 0 0 4.89 4.904"
      stroke="currentColor"
      strokeWidth={1.333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const ForwardRef = forwardRef(TrendingSvg)
export default ForwardRef
